import { useTranslation } from "react-i18next";
import { PresetSelector } from "../schedule/PresetSelector";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { ArtSection } from "./art-section/ArtSection";
import { DeveloperSection } from "./developer-section/DeveloperSection";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { MetadataBuilderPanel } from "../metadata-builder/MetadataBuilderPanel";

export function EditorPanel() {
  const { t } = useTranslation();
  const builderActive = useMetadataBuilderStore(state => state.active);
  return (
    <aside aria-label={t("editor.panel")} className="h-full min-h-0 min-w-0 overflow-hidden rounded border border-neutral-200 bg-white p-4">
      {builderActive && <MetadataBuilderPanel />}
      <div hidden={builderActive} className="h-full">
        <Tabs defaultValue="artwork" className="flex h-full min-h-0 flex-col">
          <TabsList variant="line" className="w-full shrink-0">
            <TabsTrigger value="artwork" className="flex-1">{t("art.title")}</TabsTrigger>
            <TabsTrigger value="developer" className="flex-1">{t("developer.title")}</TabsTrigger>
          </TabsList>
          <TabsContent value="artwork" className="min-h-0 flex-1 overflow-y-auto space-y-4">
            <PresetSelector />
            <ArtSection />
          </TabsContent>
          <TabsContent value="developer" className="min-h-0 flex-1 overflow-hidden">
            <DeveloperSection />
          </TabsContent>
        </Tabs>
      </div>
    </aside>
  );
}
